export default {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "",
    "image": [],
    "datePublished": "",
    "dateModified": "",
    "author": {
      "@type": "Person",
      "name": "Catherine Metrycki",
      "url": "https://callia.com/en-ca/about-callia"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Callia Flowers",
      "logo": {
        "@type": "ImageObject",
        "url": "https://callia.com/callia-logo.svg"
      }
    },
    "description": "",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": ""
    }
  }